import React from "react";

import { apiRoutes } from "configs/apiRoutes";
import CasinoPage from "./CasinoPage";

const LiveCasinoPage: React.FC = () => (
  <CasinoPage
    permissionKey="cms_widgets_live_casino"
    listRoute={apiRoutes.liveCasinoPageList}
    updateRoute={apiRoutes.liveCasinoPageUpdate}
  />
);

export default LiveCasinoPage;
